import React, {Fragment} from 'react';
import {Redirect} from "react-router-dom";
import requestApi from "../../services/requestApi.service";
import Header from "../../Layout/AppHeader";
import Common from "../../Common/Common";
import {
    getPickLists,
    updateOrganizationInfo,
    setSessionValue,
    getOrganizationInfo,
    getAppFeatureSet,
    getLogoutURL, validateLogin
} from "../../Common/Appcommon";
import {
    setAppCustomTitle
} from "../../reducers/ThemeOptions";
import {connect} from "react-redux";
class Login extends React.Component{
    constructor(props) {
        super(props);
    }

    componentDidMount = async () => {
        // let appid = getSessionValue('appid');
        // if(appid == "" || appid == null) {
            await validateLogin(this.props.history);
        // } else {
        //     this.props.history.push('/inbox');
        // }
    };


    render() {
        return (
            <Fragment>
                <div >
                    Loading
                </div>

            </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    appCustomTitle: state.ThemeOptions.appCustomTitle
});

const mapDispatchToProps = dispatch => ({
    setAppCustomTitle: title => dispatch(setAppCustomTitle(title)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
